module.exports = __webpack_public_path__ + "img/birthday-celebration.e72fecc9.png";